// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formItem--3Z2_G0wO {\n  position: relative;\n  padding-right: 20px;\n}\n\n  .formItem--3Z2_G0wO .removeIcon--EtuX29lR {\n    display: none;\n    position: absolute;\n    right: -20px;\n    top: 30px;\n  }\n\n  .formItem--3Z2_G0wO:hover .removeIcon--EtuX29lR {\n    display: block;\n  }\n\n.errorMsg--2AhdiOS- {\n  color: var(--palette-red-6);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formItem": "formItem--3Z2_G0wO",
	"removeIcon": "removeIcon--EtuX29lR",
	"errorMsg": "errorMsg--2AhdiOS-"
};
export default ___CSS_LOADER_EXPORT___;
